import Vue from 'vue'
import { AREA_INFO, ACCESS_TOKEN } from '@/store/mutation-types'
import { getAction } from '@/api/manage'

const commonData = {
  info: {
    areaInfo: []
  },

  mutations: {
    SET_AREAINFO: (info, areaInfo) => {
      info.areaInfo = areaInfo
    }
  },

  actions: {
    //获取地区数据
    GetArea({ commit }) {
      var areaInfo = Vue.ls.get(AREA_INFO)
      if (areaInfo != null && Object.keys(areaInfo).length !== 0) {
        return
      }
      return new Promise((resolve, reject) => {
        // const token = Vue.ls.get(ACCESS_TOKEN);
        getAction(`/api/area/getareas`, null)
          .then((res) => {
            if (res.success) {
              var result = res.result
              var data = {}
              for (let index = 0; index < result.length; index++) {
                const element = result[index]
                Object.assign(data, element)
              }
              Vue.ls.set(AREA_INFO, data, 7 * 24 * 60 * 60 * 1000)
              commit('SET_AREAINFO', data)
              resolve(res)
            } else {
              reject(res)
            }
          })
          .catch((error) => {
            reject(error)
          })
      })
    }
  }
}

export default commonData
